<script>
import Title from '@components/section-title'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import SimuladorAnalise from '@views/simulador-analise'
import Vue from 'vue'

export default {
  components: { Title, SimuladorAnalise },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      cliente: null,
      hash_simulacao: null,
    }
  },
  created() {
    GlobalBus.$on(MODAL.MODAL_SIMULATOR_ANALYSIS, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.MODAL_SIMULATOR_ANALYSIS, this.open)
  },
  methods: {
    open(cliente, body) {
      this.cliente = cliente
      this.selectClient(cliente)
      this.hash_simulacao = body.hash_simulacao
      this.busModal.$emit('dialog', true)

      this.$nextTick(() => {
        GlobalBus.$emit('changeClient')
      })
    },
    selectClient(cliente) {
      if (!cliente || !cliente.id) return
      this.$store.dispatch('user/addSearchClient', {
        id: cliente.id,
        id_cadastro_cliente: cliente.id_cadastro_cliente,
        name: cliente.nome_cliente || cliente.name || '',
      })
    },
    save() {
      if (this.loading) {
        return
      }
      this.loading = true

      // requisition

      this.busModal.$emit('dialog', false)
      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="1200">
    <Title
      title="Análise da simulação"
      :subtitle="cliente ? cliente.name : ''"
    />
    <SimuladorAnalise
      :cliente-modal="cliente"
      :hash-simulacao-modal="hash_simulacao"
    />

    <template v-slot:actions>
      <v-spacer />
      <v-spacer />
    </template>
  </BaseModal>
</template>


